import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { FileCheck2, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { PageHero, Kicker } from "@/components/site/shared";

export default function Quality() {
  const { t } = useTranslation();
  return (
    <div data-testid="quality-page">
      <PageHero kicker={t("quality.kicker")} title={t("quality.title")} subtitle={t("quality.subtitle")} testId="quality-hero" />

      <section className="py-20 lg:py-24">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-px bg-border border">
            {["s1", "s2", "s3", "s4"].map((k, i) => (
              <div key={k} className="bg-background p-7 lg:p-8" data-testid={`quality-step-${k}`}>
                <span className="inline-flex h-11 w-11 items-center justify-center bg-primary font-heading text-lg font-black text-primary-foreground">
                  {i + 1}
                </span>
                <h2 className="mt-5 font-heading text-lg font-bold">{t(`quality.${k}.title`)}</h2>
                <p className="mt-2 text-sm text-muted-foreground leading-relaxed">{t(`quality.${k}.desc`)}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 lg:py-24 bg-secondary/50 border-y" data-testid="certifications-section">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <Kicker>{t("quality.certsTitle")}</Kicker>
          <h2 className="mt-4 font-heading text-3xl font-extrabold tracking-tight">{t("quality.certsTitle")}</h2>
          <p className="mt-3 text-muted-foreground max-w-2xl">{t("quality.certsText")}</p>
          <div className="mt-10 grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {["cert1", "cert2", "cert3", "cert4"].map((k) => (
              <div key={k} className="border bg-card p-6 flex items-center gap-4" data-testid={`quality-${k}`}>
                <FileCheck2 className="h-7 w-7 text-primary shrink-0" />
                <p className="font-heading text-sm font-bold">{t(`quality.${k}`)}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="font-heading text-2xl sm:text-3xl font-extrabold tracking-tight">{t("cta.title")}</h2>
          <Button asChild size="lg" className="mt-6 rounded-none font-semibold h-12 px-8" data-testid="quality-cta-quote">
            <Link to="/contact">
              {t("cta.quote")}
              <ArrowRight className="ms-2 h-4 w-4 rtl:rotate-180" />
            </Link>
          </Button>
        </div>
      </section>
    </div>
  );
}
